import { ApartmentDetails } from "types/apartment";

interface Params {
  projectId: string;
  apartmentId: string;
  baseUri: string;
}

export const getApartmentDetails = async ({
  projectId,
  apartmentId,
  baseUri,
}: Params): Promise<ApartmentDetails> => {
  try {
    const response = await fetch(
      `${baseUri}/v1/spaces/project/${projectId}/apartment/${apartmentId}`,
    );
    if (!response.ok) {
      throw new Error("error fetching apartment details");
    }
    const parsedResponse = await response.json();
    return parsedResponse.data as ApartmentDetails;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error fetching apartment details:", error);
    throw error;
  }
};
